/**
 * LINE · CONTRATO ÚNICO DE CHART
 *
 * O mesmo componente aceita os parâmetros estruturais comuns aos FastCharts.
 * Aqui o `type` apenas escolhe a representação cartesiana.
 *
 * Este exemplo demonstra:
 * - lineStyle: solid | dash | dot | dash-dot;
 * - lineWidth no chart ou na série;
 * - marker da série;
 * - marker específico de um único ponto, usando o mesmo contrato;
 * - símbolo star para destacar um evento sem criar outro componente.
 */

export const modernLineChart = {
  element: 'chart',
  type: 'line',
  title: 'Monthly Average Temperature',
  subtitle: 'Source: Wikipedia.com',
  legend: 'bottom',

  lineWidth: 2.25,

  xAxis: {
    title: 'Months',
    labels: { format: '{value}' },
    // O visual moderno prioriza as guias horizontais. Grid vertical continua
    // disponível, mas não precisa competir com a série neste exemplo.
    grid: 'none'
  },

  yAxis: {
    title: 'Temperature',
    labels: { format: '{value}°' },
    grid: 'full'
  },

  series: [
    {
      name: 'Sapporo',
      lineStyle: 'dash',
      lineWidth: 2.1,
      marker: {
        enabled: true,
        shape: 'circle',
        radius: 2.7
      },
      options: {
        dataLabels: { enabled: false }
      },
      data: [
        { name: 'Jan', value: -2.9 },
        { name: 'Fev', value: -3.6 },
        { name: 'Mar', value: -0.6 },
        { name: 'Abr', value: 4.8 },
        { name: 'Mai', value: 10.2 },
        { name: 'Jun', value: 14.5 },
        { name: 'Jul', value: 17.6 },
        { name: 'Ago', value: 16.5 },
        { name: 'Set', value: 12.0 },
        { name: 'Out', value: 6.5 },
        { name: 'Nov', value: 2.0 },
        { name: 'Dez', value: -0.9 }
      ]
    },
    {
      name: 'Tokyo',
      lineStyle: 'solid',
      lineWidth: 2.6,
      marker: {
        enabled: false
      },
      options: {
        color: '#FF6000',
        dataLabels: { enabled: false }
      },
      data: [
        { name: 'Jan', value: 16.0 },
        { name: 'Fev', value: 18.2 },
        { name: 'Mar', value: 23.1 },
        { name: 'Abr', value: 27.9 },
        { name: 'Mai', value: 32.2 },
        { name: 'Jun', value: 36.4 },
        {
          name: 'Jul',
          value: 39.8,
          marker: {
            shape: 'star',
            radius: 9,
            fillColor: '#fbbf24',
            strokeColor: '#fff7d6',
            strokeWidth: 1.5
          }
        },
        { name: 'Ago', value: 38.4 },
        { name: 'Set', value: 29.2 },
        { name: 'Out', value: 22.0 },
        { name: 'Nov', value: 17.8 },
        { name: 'Dez', value: 16.2 }
      ]
    },
    {
      name: 'Reference',
      lineStyle: 'dot',
      lineWidth: 1.45,
      marker: { enabled: false },
      options: {
        color: '#9aa6b2',
        dataLabels: { enabled: false }
      },
      data: [
        { name: 'Jan', value: 25 },
        { name: 'Fev', value: 25 },
        { name: 'Mar', value: 25 },
        { name: 'Abr', value: 25 },
        { name: 'Mai', value: 25 },
        { name: 'Jun', value: 25 },
        { name: 'Jul', value: 25 },
        { name: 'Ago', value: 25 },
        { name: 'Set', value: 25 },
        { name: 'Out', value: 25 },
        { name: 'Nov', value: 25 },
        { name: 'Dez', value: 25 }
      ]
    }
  ],

  options: {
    width: 760,
    height: 456
  },

  style: {
    minWidth: '0'
  }
};

export default modernLineChart;
